import { render, staticRenderFns } from "./EditarPrecios.vue?vue&type=template&id=123df243&scoped=true"
import script from "./EditarPrecios.vue?vue&type=script&lang=js"
export * from "./EditarPrecios.vue?vue&type=script&lang=js"
import style0 from "./EditarPrecios.vue?vue&type=style&index=0&id=123df243&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123df243",
  null
  
)

export default component.exports